<template>
  <div>
    <!-- <h3>New Urls Form</h3> -->
    <v-card>
      <v-card-title></v-card-title>
      <v-card-subtitle>
        <ol>
          <!-- <li><v-icon color="warning">warning</v-icon></li> -->
          <li>
            <v-icon v-if="manufacturer_validation" color="success">verified</v-icon>
            <v-icon v-else color="warning">warning</v-icon>
            Use
            <span :class="(manufacturer_validation)?'success--text':'warning--text'">VALID</span> manufacturer.
          </li>
          <li>
            <v-icon v-if="title_validation" color="success">verified</v-icon>
            <v-icon v-else color="warning">warning</v-icon>
            Use <span :class="(title_validation)?'success--text':'warning--text'">NEW</span> name or
            existed name with <span :class="(title_validation)?'success--text':'warning--text'">DIFFERENT</span> product type.
          </li>
          <li>
            <v-icon v-if="link_validation" color="success">verified</v-icon>
            <v-icon v-else color="warning">warning</v-icon>
            At least<span :class="(link_validation)?'success--text':'warning--text'"> ONE</span> client.
          </li>
        </ol>
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col sm="12" md="2">
            <v-autocomplete
              :items="manufacturers"
              v-model="selected_manufacturer"
              :search-input.sync="new_product.manufacturer"
              noFilter
              :ripple="false"
              clearable
              outlined
              hide-details
              clear-icon
              append-icon="expand_more"
              item-text="manufacturer_name"
              item-value="manufacturer_name"
              item-color="success"
              label="Manufacturer"
              text
            >
            </v-autocomplete>
          </v-col>
          <v-col
            sm="12"
            :md="
              !new_product.title || new_product.title.length < 19 ? '2' : '3'
            "
          >
            <v-combobox
              :items="products"
              :search-input.sync="new_product.title"
              noFilter
              :ripple="false"
              clearable
              outlined
              hide-details
              clear-icon
              append-icon="expand_more"
              item-text="product_name"
              item-value="product_name"
              item-color="warning"
              label="Title"
              text
            ></v-combobox>
          </v-col>
          <v-col
            sm="12"
            :md="!selected_clients || selected_clients.length >= 4 ? '5' : '3'"
          >
            <v-select
              v-model="selected_clients"
              small-chips
              clearable
              multiple
              outlined
              hide-details
              :items="clients"
              label="Clients"
              id="clients"
            />
            <!-- :item-value="item"
              item-text="text" -->
          </v-col>
          <v-col
            sm="12"
            md="1"
          >
            <v-select
              v-model="selected_type"
              mandatory
              outlined
              hide-details
              :items="[{text: 'Exact',value: 'exact'}, {text: 'Similar',value: 'similar'}]"
              label="Type"
              id="type"
            />
          </v-col>
        </v-row>
        <div v-for="(url, index) in urls" :key="index" class="my-1">
          {{ url.domain_name }}: {{ url.url }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="help"> ADD NAME </v-btn>
        <v-btn @click="add_brand"> ADD BRAND </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="submitNewProduct"
          x-large
          color="red darken-4"
          class="me-15 px-5"
          :disabled="
            !(manufacturer_validation
            && title_validation
            && link_validation)
          "
          :loading="create_btn_loader"
        >
            <!-- [...new_product.manufacturer].length >= 2 ||
            !manufacturers.find(
              (m) => m.manufacturer_name == new_product.manufacturer
            ) ||
            !!products.find((p) => p.product_name === new_product.title) ||
            [...new_product.title].length > 2 || -->
          CREATE PRODUCT
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
/* eslint-disable */
import { eliminate_negative_ids, myCapitallize } from "@/helpers/functions";
import { productionBus } from "@/helpers/buses";

export default {
  name: "n-product-creation",
  props: {
    urls: Array,
  },
  data() {
    return {
      new_product: {
        manufacturer: "",
        title: "",
        // type: 'exact',
      },
      selected_manufacturer: "",
      manufacturers: [],
      products: [],
      selected_clients: [],
      snackbar: {
        show: false,
        text: "My timeout is set to 3000.",
        timeout: 3000,
        color: "red darken-2",
      },
      selected_type: 'exact',
      create_btn_loader: false,
    };
  },
  methods: {
    help() {
      console.log('help');
      console.log(this.manufacturer_validation)
      console.log(this.title_validation)
      console.log(this.link_validation)
      // console.log(this.manufacturers.map(m => m.manufacturer_name).includes(this.new_product.manufacturer))
      // console.log(this.manufacturers.map(m => m.manufacturer_name))
      // console.log(this.manufacturers.find(m => m.manufacturer_id === this.vmd_new_product.manufacturer).manufacturer_name)
      // console.log(this.manufacturers.map(m => m.manufacturer_name).includes(
      //             this.manufacturers.find(m => m.manufacturer_id === this.vmd_new_product.manufacturer).manufacturer_name
      //           ))
      },
    check_written_field(type, value) {
      const data = {
        task: `searching${myCapitallize(JSON.parse(JSON.stringify(type)))}`,
        payload: { value },
      };
      console.log("test data ", data);
      this.$store.dispatch("productionModule/general_api", data).then((res) => {
        const results = res.data.payload;
        console.log("rtesults", results);
        // this[`products`] = (results.status == 'success') ? results['products'] : [];
        this[`${type}s`] =
          results.status == "success" ? results[`${type}s`] : [];
      });
    },
    submitNewProduct() {
      this.create_btn_loader = true;
      const respond_data = {
        task: "saveNewProduct",
        payload: {
          manufacturer_id: this.manufacturers.find(
            (m) => m.manufacturer_name == this.new_product.manufacturer
          ).manufacturer_id,
          product_name: this.new_product.title,
          clients: this.clients.filter((client) =>
            this.selected_clients.includes(client.value)
          ),
          product_pending: eliminate_negative_ids(
            this.$store.state.productionModule.valid_domains_urls
          ),
          product_info: this.create_new_product_info(),
        },
      };
      console.log("respond_data", respond_data);
      // const data = {
      //   task: "saveNewProduct",
      //   payload: {
      //     product_pending,
      //     product_info,
      //     clients,
      //   },
      // };
      this.$store
        .dispatch("productionModule/general_api", respond_data)
        .then((res) => {
          if (!res.data.payload) {
            this.snackbar.color = "red darken-2";
            this.snackbar.text = "Error: The product does not created.";
            this.snackbar.show = true;
          } else {
            this.snackbar.color = "blue-grey";
            this.snackbar.text = `Created Product ${this.new_product.title}`;
            this.snackbar.show = true;
            const results = res.data.payload;
            // this.$store.commit("productionModule/SET_PRODUCTION_STATE", {
            //   key: "selected_product.id",
            //   value: results.info.product_id,
            // });

            // this.$store.state.productionModule.selected_product.id =
            //   results.info.product_brand.id;
            // setTimeout(
            //   function(that = this) {
            //     that.$store.commit("productionModule/SET_PRODUCTION_STATE", {
            //       key: "valid_domains_urls",
            //       value: [],
            //     });

            //   }, 3000);
            // this.$emit("created_new_product");

            // productionBus.$emit("open_snackbar", {text:`Created Product ${this.new_product.title}`});
            // productionBus.$emit('loadProduct', results.info.product_id);
            // this.$router.push({ name: "product-table" });
          }
        }).catch(err => {
          console.log('ftiakse to error', err)
          this.snackbar.color = "red darken-2";
          this.snackbar.text = "Error: The product does not created.";
          this.snackbar.show = true;
        }).finally(() => this.create_btn_loader = false );
    },
    create_new_product_info() {
      const found_product = this.products.find(
        (p) => this.new_product.title == p.product_name
      );
      return {
        created_at: { date: "", time: "" },
        product_brand: {
          id: this.manufacturers.find(
            (m) => m.manufacturer_name === this.selected_manufacturer
          ).manufacturer_id,
          name: this.selected_manufacturer,
        },
        product_id: found_product === undefined ? 0 : found_product.product_id,
        product_name: this.new_product.title,
        product_source: "",
        product_type: this.selected_type,
      };
    },
    add_brand() {},
  },
  watch: {
    "new_product.manufacturer"(newValue) {
      if (newValue && newValue.length >= 2) {
        this.check_written_field("manufacturer", newValue);
      }
    },
    "new_product.title"(newValue) {
      if (newValue && newValue.length >= 2) {
        this.check_written_field("product", newValue);
      }
    },
  },
  computed: {
    clients() {
      return this.$store.state.productionModule.clients_list;
    },
    manufacturer_validation() {
      return this.manufacturers.map(m => m.manufacturer_name).includes(this.new_product.manufacturer)
              && this.selected_manufacturer === this.new_product.manufacturer;
    },
    // manufacturer_validation() {
    //   return this.manufacturers.map(m => m.manufacturer_name).includes(this.new_product.manufacturer)
    //           && this.manufacturers.map(m => m.manufacturer_name).includes(
    //               this.manufacturers.find(m => m.manufacturer_id === this.selected_manufacturer).manufacturer_name
    //             );
    // },
    title_validation() {
      return (!this.products.map(p => p.product_name).includes(this.new_product.title)
                // && this.vmd_new_product.title === this.new_product.title
                && this.new_product.title
                && this.new_product.title.length > 3)
            || (this.products.map(p => p.product_name).includes(this.new_product.title)
                && this.products.find(p => p.product_name.toLowerCase() == this.new_product.title.toLowerCase()).product_type != this.selected_type)
    },
    link_validation() {
      return !!this.selected_clients.length;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/production/N_ProductCreation.vue